export default "__VITE_ASSET__B7M15VWw__"